module.exports = __webpack_public_path__ + "img/C25.ff03b073.png";